import { gql } from "@apollo/client";

export const GET_CONFORMIDADES_BOT = gql`
query GetConformidadesBOT($filters: ReporteBOTFilterInput!) {
  conformidadesBOT(filters: $filters) {
    success,
    error,
    valorEsperado {
      idFormRef
      referencia
      numero
      hc
      paciente
      contrato
      mes
      cliente
      origen
      documento
      estado
      fechaalta
    }
  }            
}`;